const getPayments = new Map([
  ['Credit/Debit-POS', 'POS Credit Card/Debit Card'],
  ['Credit/Debit-Online', 'Online CC/DC/Net Banking'],
  ['Credit/Debit-Online', 'Online CC/DC/Net Banking'],
  ['581', 'Online CC/DC/Net Banking'],
  ['582', 'Online CC/DC/Net Banking'],
  ['UPI Acceptance', 'UPI'],
  ['566', 'UPI'],
  ['Wallet Acceptance', 'Wallets'],
  ['579', 'Wallets'],
  ['Hyperlocal Payment Acceptance', 'Hyperlocal Payment Acceptance'],
  ['Supplier Payment Acceptance', 'Supplier Payment Acceptance'],
  ['Sodexo', 'Sodexo'],
  ['BULK_REFUND', 'BULK_REFUND'],
])

const PaymentAcceptanceParser = (data: any): any => {
  const { response } = data
  const payments =
    response?.configValues.reduce((payments: any, item: any) => {
      if (item.value === 'Y' && getPayments.get(item.key)) {
        payments.push(getPayments.get(item.key))
      }
      return payments
    }, []) ?? []

  return payments
}

export { PaymentAcceptanceParser }
